import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from 'infrastructure/common/model/api.query';
import { UserTaskExportTaskStatus } from 'user/model/user-task-export-task-status';

export interface CanExportUserMeetingsParams {
	readonly userId: string;
	readonly participantId: string;
	readonly exportTaskId: string;
}

@Injectable({ providedIn: 'root' })
export class CanExportUserMeetingsApiQuery extends ApiQuery<
	UserTaskExportTaskStatus,
	CanExportUserMeetingsParams
> {
	client = 'iam';
	document = gql`
		query CanExportUserMeetings(
			$exportTaskId: UUID
			$participantId: UUID!
			$userId: UUID!
		) {
			canExportUserMeetings(
				exportTaskId: $exportTaskId
				participantId: $participantId
				userId: $userId
			)
		}
	`;
	method = 'canExportUserMeetings';
}
